//import external libraries
import {
  React,
  useReducer,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

//import intenal resources and services
import {
  calculateAritmeticMeanTemperature,
  calculatePartialWaterVaporSaturationPressure100,
  calculatePartialWaterVaporSaturationPressure,
  calculateAbsHumidityPoolArea,
  calculatRelNeckMassageShower,
  calculateAttractionsBetaA,
  calculateRelBubbleFontains,
  calculateRelUnderwaterJets,
  calculateRelMassageAreas,
  calculateRelWildWater,
  calculateRelWaterMushrooms,
  calculateRelChildrenSlides,
  calculateRelLoungersSeats,
  calculateAttractionsRel,
  calculateAttractionsSUM,
  calculateMoistureFromVisitors,
  calculateMoistureTransferCoeffUnusedPool,
  calculateMoistureTransferCoeffUsedPool,
  calculateMassFlowOfWaterUnusedPool,
  calculateMassFlowOfWaterAttraction,
  calculateMassFlowOfWaterUsedPool,
  calculateTotalMassFlowOfWater,
  calculateMassFlowOutsideAir,
  calculateMaximumRequiredAmountOfAir,
  calculateMinimimReqiredAmountOfFreshAir,
  calculateNumberOfAirChangesPoolArea,
  calculateMoistureTransferCoeffAttractions,
  calculateDehumidificationCapacity,
} from "../../utils/hydraCalculations";
import {
  createHydraItem,
  editHydraItem,
  getHydraTypes,
} from "../../utils/services/projectService";
import { appCtx } from "../../utils/hooks/appContext";
import { setSnackbar } from "../../actions/snackbarActions";
import { sizeOfUnitMapping } from "../../utils/unitConstants";

//import MUI components
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import useTheme from "@mui/material/styles/useTheme";

const hydraUnitReducer = (state, action) => {
  console.log("Pokrenuta je akcija " + action.type);
  switch (action.type) {
    case "updateHydraUnit":
      //if (action.payload.name === "poolVolume")
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case "calArithmeticMeanTemp":
      let aritmeticMean;
      let partSaturation100;
      let partSaturation;
      let absHumPool;

      aritmeticMean = calculateAritmeticMeanTemperature(
        state.airTemperature,
        state.waterTemperature
      );
      partSaturation100 = calculatePartialWaterVaporSaturationPressure100(
        state.waterTemperature
      );
      partSaturation = calculatePartialWaterVaporSaturationPressure(
        state.airTemperature,
        state.airHumidity
      );

      absHumPool = calculateAbsHumidityPoolArea(
        state.airTemperature,
        state.airHumidity
      );

      return {
        ...state,
        arithmeticMeanTemperature: aritmeticMean,
        partialWaterVaporSaturationPressure100: partSaturation100,
        partialWaterVaporSaturationPressure: partSaturation,
        absoluteHumidityPoolArea: absHumPool,
      };
    case "updateAttractionWildWater":
      let relWildWater = calculateRelWildWater(state.wildWaterChannels);

      return {
        ...state,
        relWildWater: relWildWater,
        // [action.payload.name]: action.payload.value,
      };
    case "updateAttractionWaterMushrooms":
      let relWaterMushrooms = calculateRelWaterMushrooms(
        state.waterMushrooms,
        state.waterMushroomsMeters
      );

      return {
        ...state,
        relWaterMushrooms: relWaterMushrooms,
      };
    case "updateAttractionNeckMassageShower":
      let relNeckMassageShower = calculatRelNeckMassageShower(
        action.payload.value
      );

      return {
        ...state,
        relNeckMassageShowers: relNeckMassageShower,
        //[action.payload.name]: action.payload.value,
      };
    case "updateAttractionunderwaterJets":
      let relUnderwaterJets = calculateRelUnderwaterJets(action.payload.value);

      return {
        ...state,
        relUnderwaterJets: relUnderwaterJets,
        //[action.payload.name]: +action.payload.value,
      };
    case "updateAttractionBubbleFontains":
      let relBubbleFountains = calculateRelBubbleFontains(action.payload.value);

      return {
        ...state,
        relBubbleFountains: relBubbleFountains,
        //[action.payload.name]: action.payload.value,
      };
    case "updateAttractionChildrenSlides":
      let relChildrenSlides = calculateRelChildrenSlides(action.payload.value);

      return {
        ...state,
        relChildrenSlides: relChildrenSlides,
        // [action.payload.name]: action.payload.value,
      };
    case "updateAttractionMassageAreas":
      let relMassageAreas = calculateRelMassageAreas(action.payload.value);

      return {
        ...state,
        relMassageAreas: relMassageAreas,
        //[action.payload.name]: action.payload.value,
      };
    case "updateAttractionLoungersSeats":
      let relLoungersSeats = calculateRelLoungersSeats(action.payload.value);

      return {
        ...state,
        relLoungersSeats: relLoungersSeats,
        //[action.payload.name]: action.payload.value,
      };

    case "updateAttractionSum":
      let sum = calculateAttractionsSUM(
        action.payload.relBubbleFountains,
        action.payload.relWildWater,
        action.payload.relWaterMushrooms,
        action.payload.relUnderwaterJets,
        action.payload.relNeckMassageShowers,
        action.payload.relMassageAreas,
        action.payload.relChildrenSlides,
        action.payload.relLoungersSeats
      );

      return {
        ...state,
        sum: sum,
      };
    case "updateBetaA":
      const dataSum = [
        5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
        95, 100,
      ];
      const dataDeltaB = [
        2.5, 6.5, 10, 13.5, 16, 18, 19, 21, 22, 23, 24, 24.5, 25.5, 26, 27,
        27.5, 28, 28.5, 28.75, 29,
      ];
      let betaA = calculateAttractionsBetaA(
        state.sum, //action.payload.sum,
        dataSum,
        dataDeltaB
      );
      const coefAttractions = calculateMoistureTransferCoeffAttractions(betaA);
      return {
        ...state,
        betaA: betaA,
        moistureTransferCoefficientAttraction: coefAttractions,
      };
    case "updateVisitors":
      let visitorsMoisture = calculateMoistureFromVisitors(
        action.payload.value
      );
      return {
        ...state,
        amountMoistureVisitors: visitorsMoisture,
        [action.payload.name]: action.payload.value,
      };
    case "updateMoistureTransCoeffPool":
      let unusedPool = calculateMoistureTransferCoeffUnusedPool(
        action.payload.value
      );
      let usedPool = calculateMoistureTransferCoeffUsedPool(
        action.payload.value
      );

      return {
        ...state,
        moistureTransferCoefficientUnusedPool: unusedPool,
        moistureTransferCoefficientUsedPool: usedPool,
        // [action.payload.name]: action.payload.value,
      };
    case "calculateMassFlow":
      let flowUnusedPool = calculateMassFlowOfWaterUnusedPool(
        action.payload.waterSurface,
        action.payload.gasConstant,
        action.payload.typeOfPool,
        action.payload.airTemperature,
        action.payload.airHumidity,
        action.payload.waterTemperature
      );
      let flowUsedPool = calculateMassFlowOfWaterUsedPool(
        action.payload.waterSurface,
        action.payload.gasConstant,
        action.payload.typeOfPool,
        action.payload.airTemperature,
        action.payload.airHumidity,
        action.payload.waterTemperature
      );
      let flowAttraction = calculateMassFlowOfWaterAttraction(
        action.payload.waterSurface,
        action.payload.gasConstant,
        action.payload.typeOfPool,
        action.payload.airTemperature,
        action.payload.airHumidity,
        action.payload.waterTemperature,
        state.betaA
      );

      return {
        ...state,
        massFlowWaterUnusedPool: flowUnusedPool,
        massFlowWaterUsedPool: flowUsedPool,
        massFlowWaterFromAttraction: flowAttraction,
      };
    case "calculateTotalMassFlow":
      let total = calculateTotalMassFlowOfWater(
        action.payload.massFlowWaterFromAttraction,
        action.payload.massFlowWaterUsedPool,
        action.payload.amountMoistureVisitors
      );

      return {
        ...state,
        totalMassFlowWaterUsedPool: total,
      };
    case "calculateMassFlowOutsideAir":
      let massFlowOutsideAir = calculateMassFlowOutsideAir(
        action.payload.massFlowWaterUnusedPool,
        action.payload.totalMassFlowWaterUsedPool,
        action.payload.absoluteHumidityPoolArea,
        action.payload.absoluteHumidityAir
      );
      return {
        ...state,
        massFlowOutsideAir: massFlowOutsideAir,
      };
    case "updateMaxRequiredAmoutOfOutsideAir":
      let maxRequiredAir = calculateMaximumRequiredAmountOfAir(
        action.payload.massFlowOutsideAir
      );
      let minRequiredFreshAir =
        calculateMinimimReqiredAmountOfFreshAir(maxRequiredAir);
      let numOfAirChanges = calculateNumberOfAirChangesPoolArea(
        maxRequiredAir,
        state.poolVolume
      );

      return {
        ...state,
        maxRequiredAir: maxRequiredAir,
        minRequiredFreshAir: minRequiredFreshAir,
        numOfAirChanges: numOfAirChanges,
      };
    case "updateNumberOfAirChanges":
      let numberAirChanges = calculateNumberOfAirChangesPoolArea(
        state.maxRequiredAir,
        action.payload.value
      );
      return {
        ...state,
        numOfAirChanges: numberAirChanges,
        // [action.payload.name]: action.payload.value,
      };
    case "updateUnitDetails":
      return {
        ...state,
        unitTypeId: action.payload.id,
        unitSize: action.payload.unit,
        width: action.payload.width,
        length: action.payload.lengthPoly,
        height: action.payload.height,
        unitWeight: action.payload.weightPoly,
        price: action.payload.price,
      };
    case "updateAirFlowPerUnit":
      return {
        ...state,
        airFlowPerUnit: action.payload.airFlowPerUnit,
      };
    case "updateDehumidification":
      const dehum = calculateDehumidificationCapacity(
        action.payload.maxRequiredAir
      );
      return {
        ...state,
        dehumidificationCapacity: dehum,
      };

    default:
      return state;
  }
};

function DehumidifyCalc() {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatchSnackbar = useDispatch();
  const location = useLocation();

  const isFirstRender = useRef(true);
  //Id projekta se dobija iz konteksta
  const { projectId } = useContext(appCtx);

  const initialState = {
    name: "",
    poolName: "",
    typeOfPool: "Private pool",
    poolVolume: 200,
    waterSurface: 30,
    //Thermodynamic parameters of the pool area
    airTemperature: 32,
    waterTemperature: 30,
    arithmeticMeanTemperature: 304,
    gasConstant: 461.52,
    airHumidity: 48,
    //Pressures
    partialWaterVaporSaturationPressure100: 4244,
    partialWaterVaporSaturationPressure: 2283,
    //Absolute humidity
    absoluteHumidityPoolArea: 0.0145,
    absoluteHumidityAir: 0.009,
    //  Attractions
    wildWaterChannels: 0,
    waterMushrooms: 0,
    waterMushroomsMeters: 0,
    neckMassageShowers: 0,
    underwaterJets: 0,
    bubbleFountains: 0,
    childrenSlides: 0,
    massageAreas: 0,
    loungersSeats: 0,
    relWildWater: 0,
    relWaterMushrooms: 0,
    relNeckMassageShowers: 0,
    relUnderwaterJets: 0,
    relBubbleFountains: 0,
    relChildrenSlides: 0,
    relMassageAreas: 0,
    relLoungersSeats: 0,

    sum: 0,
    betaA: 0,
    simultaneityFactorAttraction: 1,
    numberOfVisitors: 10,
    //Maximum amount calculation of evaporated water
    moistureTransferCoefficientUnusedPool: 7,
    moistureTransferCoefficientUsedPool: 21,
    moistureTransferCoefficientAttraction: 0,
    amountMoistureVisitors: 0.6,
    massFlowWaterUnusedPool: 2.93,
    massFlowWaterUsedPool: 8.8,
    massFlowWaterFromAttraction: 0,
    totalMassFlowWaterUsedPool: 9.4,
    // Maximum air volume required for dehumidification
    massFlowOutsideAir: 1700,
    maxRequiredAir: 1400,
    minRequiredFreshAir: 500,
    numOfAirChanges: 7,
    //    AHU selection size
    unitType: "HYDRApro COMPACT BASIC",
    unitTypeId: 1,
    unitSize: "06.03",
    numOfUnits: 1,
    airFlowPerUnit: 0,
    width: 0,
    height: 0,
    length: 0,
    unitWeight: 0,
    dehumidificationCapacity: 0,
    price: 0,
  };
  const [unitTypes, setUnitTypes] = useState([
    { type: "HYDRApro COMPACT BASIC" },
    { type: "HYDRApro COMPACT GENIUS" },
    { type: "HYDRApro BASIC" },
    { type: "HYDRApro GENIUS" },
  ]);
  const [unitSizes, setUnitSizes] = useState([]);
  const [ahuSelectionOptions, setAhuSelectionOptions] = useState([]);
  const [showAttractions, setShowAttractions] = useState(false);

  function findUnitType(unitID) {
    if (unitID < 9) return "HYDRApro COMPACT BASIC";
    else if (unitID > 22) return "HYDRApro GENIUS";
    else return "HYDRApro BASIC";
  }

  const typesOfPool = [
    {
      name: t("hydraPro.option1"),
      value: "Covered pool (only the topping evaporates)",
    },
    { name: t("hydraPro.option2"), value: "Private pool" },
    { name: t("hydraPro.option3"), value: "Public pool depth < 1,35 m" },
    { name: t("hydraPro.option4"), value: "Public pool depth > 1,35 m" },
    { name: t("hydraPro.option5"), value: "Wave pool" },
    { name: t("hydraPro.option6"), value: "Pool with water slide system" },
    {
      name: t("hydraPro.option7"),
      value: "Water slide system for water collection",
    },
  ];

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (e.target.type === "checkbox" || e.target.type === "switch") {
      value = e.target.checked;
    }

    //Za tekstualna polja ce biti postavljena vrednost koju vraca event
    if (
      name === "name" ||
      name === "poolName" ||
      name === "typeOfPool" ||
      name === "unitType" ||
      name === "unitSize"
    ) {
      dispatch({ type: "updateHydraUnit", payload: { name, value } });
    }
    //Za numericka polja konvertujemo string u number
    else
      dispatch({ type: "updateHydraUnit", payload: { name, value: +value } });
  };
  const [hydraUnit, dispatch] = useReducer(hydraUnitReducer, initialState);

  useEffect(() => {
    //Ukoliko se kreira nova pozicija postavljamo na inicijalne vrednosti padajuce liste
    if (location.state === null) {
      //vraca sve tipove i velicine komora koje odgovaraju flow-u
      getHydraTypes(hydraUnit.maxRequiredAir)
        .then((res) => {
          //Kreira se niz jedinstvenih vrednosti za tipove komore
          const unique = Array.from(new Set(res.data.map((item) => item.type)));

          setUnitTypes(unique);
          //Ceo rezultat se smesta u ahuSelection
          setAhuSelectionOptions(res.data);
          const filteredSizes = res.data.filter(
            (item) => item.type === hydraUnit.unitType
          );

          const formattedSizes = Array.from(
            new Set(filteredSizes.map((item) => item.unit))
          );
          setUnitSizes(formattedSizes);

          //Vraca niz objekata sa svim potrebnim podacima o komori kao sto su tip, velicina i dimenzije
          const unitDetails = res.data.filter(
            (item) =>
              item.type === hydraUnit.unitType &&
              item.unit === hydraUnit.unitSize
          );
          //Inicijalno se postavljaju podaci o prvoj komori u listi
          dispatch({
            type: "updateUnitDetails",
            payload: unitDetails[0],
          });
        })
        .catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    //Pri izmeni pozicije setuje vrednosti na vrednosti iz baze
    //Location.state sadrzi objekat sa svim vrednostima iz baze
    if (location.state !== null) {
      //prolazi se kroz polja objekta i menja se polje koje je sadr\ano u bazi
      //PROVERI da li se pokrece izmena nad poljima objekta i odgovarajuce dodatne kalkulacije
      for (const [key, value] of Object.entries(location.state)) {
        console.log(key + " je " + value);
        if (key === "maxRequiredAir") {
          console.log(value);
          getHydraTypes(value)
            .then((res) => {
              const unique = Array.from(
                new Set(res.data.map((item) => item.type))
              );
              setUnitTypes(unique);

              setAhuSelectionOptions(res.data);
              let unitType = findUnitType(location.state.unitTypeId);

              const filteredSizes = res.data.filter(
                (item) => item.type === unitType
              );
              const formattedSizes = Array.from(
                new Set(filteredSizes.map((item) => item.unit))
              );
              setUnitSizes(formattedSizes);
              let updateDetails = ahuSelectionOptions.filter(
                (item) =>
                  item.unit === sizeOfUnitMapping[location.state.unitTypeId] &&
                  item.type === unitType
              );

              //PROVERITI - kod izmene pozicije ne menja ove vrednosti
              if (updateDetails.length > 0)
                dispatch({
                  type: "updateUnitDetails",
                  payload: updateDetails[0],
                });
            })
            .catch((err) => console.log(err));
        } else if (key === "unitTypeId") {
          let unitTypeName = findUnitType(value);
          dispatch({
            type: "updateHydraUnit",
            payload: { name: "unitType", value: unitTypeName },
          });

          dispatch({
            type: "updateHydraUnit",
            payload: { name: "unitSize", value: sizeOfUnitMapping[value] },
          });
        }

        dispatch({
          type: "updateHydraUnit",
          payload: { name: key, value: value },
        });
      }
    }
  }, []);

  useEffect(() => {
    dispatch({
      type: "calArithmeticMeanTemp",
      payload: {
        airTemperature: hydraUnit.airTemperature,
        waterTemperature: hydraUnit.waterTemperature,
      },
    });
  }, [
    hydraUnit.airTemperature,
    hydraUnit.waterTemperature,
    hydraUnit.airHumidity,
  ]);

  //Attractions
  useEffect(() => {
    dispatch({
      type: "updateAttractionWildWater",
      payload: {
        name: "wildWaterChannels",
        // value: hydraUnit.wildWaterChannels,
      },
    });
  }, [hydraUnit.wildWaterChannels]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionWaterMushrooms",
    });
  }, [hydraUnit.waterMushrooms, hydraUnit.waterMushroomsMeters]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionunderwaterJets",
      payload: { name: "underwaterJets", value: hydraUnit.underwaterJets },
    });
  }, [hydraUnit.underwaterJets]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionBubbleFontains",
      payload: { name: "bubbleFountains", value: hydraUnit.bubbleFountains },
    });
  }, [hydraUnit.bubbleFountains]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionNeckMassageShower",
      payload: {
        name: "neckMassageShowers",
        value: hydraUnit.neckMassageShowers,
      },
    });
  }, [hydraUnit.neckMassageShowers]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionChildrenSlides",
      payload: { name: "childrenSlides", value: hydraUnit.childrenSlides },
    });
  }, [hydraUnit.childrenSlides]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionMassageAreas",
      payload: { name: "massageAreas", value: hydraUnit.massageAreas },
    });
  }, [hydraUnit.massageAreas]);
  useEffect(() => {
    dispatch({
      type: "updateAttractionLoungersSeats",
      payload: { name: "loungersSeats", value: hydraUnit.loungersSeats },
    });
  }, [hydraUnit.loungersSeats]);

  useEffect(() => {
    dispatch({
      type: "updateAttractionSum",
      payload: {
        relBubbleFountains: hydraUnit.relBubbleFountains,
        relWildWater: hydraUnit.relWildWater,
        relWaterMushrooms: hydraUnit.relWaterMushrooms,
        relUnderwaterJets: hydraUnit.relUnderwaterJets,
        relNeckMassageShowers: hydraUnit.relNeckMassageShowers,
        relMassageAreas: hydraUnit.relMassageAreas,
        relChildrenSlides: hydraUnit.relChildrenSlides,
        relLoungersSeats: hydraUnit.relLoungersSeats,
      },
    });
    dispatch({
      type: "updateBetaA",
      payload: {
        sum: hydraUnit.sum,
      },
    });
  }, [
    hydraUnit.relBubbleFountains,
    hydraUnit.relWildWater,
    hydraUnit.relWaterMushrooms,
    hydraUnit.relUnderwaterJets,
    hydraUnit.relNeckMassageShowers,
    hydraUnit.relMassageAreas,
    hydraUnit.relChildrenSlides,
    hydraUnit.relLoungersSeats,
  ]);

  useEffect(() => {
    dispatch({
      type: "updateVisitors",
      payload: { name: "numberOfVisitors", value: hydraUnit.numberOfVisitors },
    });
  }, [hydraUnit.numberOfVisitors]);
  //Maximum amount calculation of evaporated water
  useEffect(() => {
    dispatch({
      type: "updateMoistureTransCoeffPool",
      payload: {
        name: "typeOfPool",
        value: hydraUnit.typeOfPool,
      },
    });
  }, [hydraUnit.typeOfPool]);
  useEffect(() => {
    dispatch({
      type: "updateNumberOfAirChanges",
      payload: { name: "poolVolume", value: hydraUnit.poolVolume },
    });
  }, [hydraUnit.poolVolume]);

  useEffect(() => {
    dispatch({
      type: "calculateMassFlow",
      payload: {
        waterSurface: hydraUnit.waterSurface,
        gasConstant: hydraUnit.gasConstant,
        typeOfPool: hydraUnit.typeOfPool,
        airTemperature: hydraUnit.airTemperature,
        airHumidity: hydraUnit.airHumidity,
        waterTemperature: hydraUnit.waterTemperature,
      },
    });
  }, [
    hydraUnit.waterSurface,
    hydraUnit.typeOfPool,
    hydraUnit.airTemperature,
    hydraUnit.airHumidity,
    hydraUnit.waterTemperature,
    hydraUnit.betaA,
  ]);

  useEffect(() => {
    dispatch({
      type: "calculateTotalMassFlow",
      payload: {
        massFlowWaterFromAttraction: hydraUnit.massFlowWaterFromAttraction,
        massFlowWaterUsedPool: hydraUnit.massFlowWaterUsedPool,
        amountMoistureVisitors: hydraUnit.amountMoistureVisitors,
      },
    });
  }, [
    hydraUnit.massFlowWaterFromAttraction,
    hydraUnit.massFlowWaterUsedPool,
    hydraUnit.amountMoistureVisitors,
  ]);
  //Maximum air volume required for dehumidification
  useEffect(() => {
    dispatch({
      type: "calculateMassFlowOutsideAir",
      payload: {
        massFlowWaterUnusedPool: hydraUnit.massFlowWaterUnusedPool,
        totalMassFlowWaterUsedPool: hydraUnit.totalMassFlowWaterUsedPool,
        absoluteHumidityPoolArea: hydraUnit.absoluteHumidityPoolArea,
        absoluteHumidityAir: hydraUnit.absoluteHumidityAir,
      },
    });
  }, [
    hydraUnit.massFlowOfWaterUnusedPool,
    hydraUnit.totalMassFlowWaterUsedPool,
    hydraUnit.absoluteHumidityPoolArea,
    hydraUnit.absoluteHumidityAir,
  ]);

  useEffect(() => {
    dispatch({
      type: "updateMaxRequiredAmoutOfOutsideAir",
      payload: {
        massFlowOutsideAir: hydraUnit.massFlowOutsideAir,
      },
    });
  }, [hydraUnit.massFlowOutsideAir]);

  //AHU selection size
  useEffect(() => {
    getHydraTypes(hydraUnit.maxRequiredAir)
      .then((res) => {
        const unique = Array.from(new Set(res.data.map((item) => item.type)));
        setUnitTypes(unique);
        setAhuSelectionOptions(res.data);
        const filteredSizes = res.data.filter(
          (item) => item.type === hydraUnit.unitType
        );
        const formattedSizes = Array.from(
          new Set(filteredSizes.map((item) => item.unit))
        );
        setUnitSizes(formattedSizes);
        if (ahuSelectionOptions.length > 0) {
          const unitDetails = ahuSelectionOptions.filter(
            (item) =>
              item.type === hydraUnit.unitType &&
              item.unit === hydraUnit.unitSize
          );

          unitDetails.length > 0 &&
            dispatch({
              type: "updateUnitDetails",
              payload: unitDetails[0],
            });
        }
      })
      .catch((err) => console.log(err));

    dispatch({
      type: "updateDehumidification",
      payload: {
        maxRequiredAir: hydraUnit.maxRequiredAir,
      },
    });
  }, [hydraUnit.maxRequiredAir]);

  useEffect(() => {
    //Prilikom izbora tipa komore menja dozvoljene velicine
    const filteredSizes = ahuSelectionOptions.filter(
      (item) => item.type === hydraUnit.unitType
    );
    const formattedSizes = Array.from(
      new Set(filteredSizes.map((item) => item.unit))
    );
    setUnitSizes(formattedSizes);
  }, [hydraUnit.unitType]);

  /*useEffect(() => {
    //Kada se nove promeni max required air dovuku se novi podaci o dostupnim tipovima i jedinicama
    //Postavlja na prvu opciju u nizu
    console.log(ahuSelectionOptions);
    if (ahuSelectionOptions.length > 0) {
      console.log(hydraUnit.unitType + "i" + hydraUnit.unitSize);
      const unitDetails = ahuSelectionOptions.filter(
        (item) =>
          item.type === hydraUnit.unitType && item.unit === hydraUnit.unitSize
      );
      console.log(unitDetails);
      console.log("druga");
      unitDetails.length > 0 &&
        dispatch({
          type: "updateUnitDetails",
          payload: unitDetails[0],
        });
    }
  }, [ahuSelectionOptions]);*/

  useEffect(() => {
    const airFlowPerUnit = +hydraUnit.maxRequiredAir / +hydraUnit.numOfUnits;
    dispatch({
      type: "updateAirFlowPerUnit",
      payload: {
        airFlowPerUnit: airFlowPerUnit,
      },
    });
  }, [hydraUnit.numOfUnits, hydraUnit.maxRequiredAir]);

  useEffect(() => {
    if (isFirstRender.current && location.state === null) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    //Kada se promeni velicina komore povuce
    console.log(ahuSelectionOptions);

    let updateDetails = ahuSelectionOptions.filter(
      (item) =>
        item.unit === hydraUnit.unitSize && item.type === hydraUnit.unitType
    );
    console.log(ahuSelectionOptions);
    console.log(hydraUnit.unitSize);
    //PROVERITI - kod izmene pozicije ne menja ove vrednosti
    if (updateDetails.length > 0)
      dispatch({
        type: "updateUnitDetails",
        payload: updateDetails[0],
      });
  }, [hydraUnit.unitSize]);

  function validateMandatoryFields(createRequest) {
    if (
      createRequest.projectId !== "" &&
      createRequest.name !== "" &&
      createRequest.poolName !== "" &&
      createRequest.typeOfPool !== "" &&
      createRequest.poolVolume !== 0 &&
      createRequest.waterSurface !== 0 &&
      createRequest.airTemperature !== 0 &&
      createRequest.waterTemperature !== 0 &&
      createRequest.maxRequiredAir !== 0 &&
      createRequest.minRequiredFreshAir !== 0 &&
      createRequest.numOfAirChanges !== 0 &&
      createRequest.airHumidity !== 0 &&
      createRequest.unitTypeId !== 0 &&
      createRequest.numOfUnits !== 0 &&
      createRequest.price !== 0
    )
      return true;
    else return false;
  }

  function createPosition() {
    const createRequest = {
      positionId: hydraUnit.id,
      projectId: projectId,
      revisionNumber: 0,
      name: hydraUnit.name,
      poolName: hydraUnit.poolName,
      typeOfPool: hydraUnit.typeOfPool,
      poolVolume: hydraUnit.poolVolume,
      waterSurface: hydraUnit.waterSurface,
      airTemperature: hydraUnit.airTemperature,
      waterTemperature: hydraUnit.waterTemperature,
      maxRequiredAir: hydraUnit.maxRequiredAir,
      minRequiredFreshAir: hydraUnit.minRequiredFreshAir,
      numOfAirChanges: hydraUnit.numOfAirChanges,
      airHumidity: hydraUnit.airHumidity,
      absoluteHumidityAir: hydraUnit.absoluteHumidityAir,
      //  Attractions
      wildWaterChannels: hydraUnit.wildWaterChannels,
      waterMushrooms: hydraUnit.waterMushrooms,
      waterMushroomsMeters: hydraUnit.waterMushroomsMeters,
      neckMassageShowers: hydraUnit.neckMassageShowers,
      underwaterJets: hydraUnit.underwaterJets,
      bubbleFountains: hydraUnit.bubbleFountains,
      childrenSeats: hydraUnit.childrenSeats,
      childrenSlides: hydraUnit.childrenSlides,
      massageAreas: hydraUnit.massageAreas,
      loungersSeats: hydraUnit.loungersSeats,

      simultaneityFactorAttraction: hydraUnit.simultaneityFactorAttraction,
      numberOfVisitors: hydraUnit.numberOfVisitors,
      unitTypeId: hydraUnit.unitTypeId,
      numOfUnits: hydraUnit.numOfUnits,
      price: hydraUnit.price,
    };

    if (validateMandatoryFields(createRequest)) {
      location.state !== null
        ? editHydraItem(createRequest)
            .then((res) => {
              if (res.statusCode >= 200 && res.statusCode < 300) {
                dispatchSnackbar(
                  setSnackbar(
                    true,
                    "success",
                    t("snackbar.editProjectItemSuccess"),
                    "/project-item",
                    { replace: true }
                  )
                );
              }
            })
            .catch((err) => {
              dispatchSnackbar(
                setSnackbar(true, "error", t("snackbar.createProjectItemError"))
              );
            })
        : createHydraItem(createRequest)
            .then((res) => {
              if (res.statusCode >= 200 && res.statusCode < 300) {
                dispatchSnackbar(
                  setSnackbar(
                    true,
                    "success",
                    t("snackbar.createProjectItemSuccess"),
                    "/project-item",
                    { replace: true }
                  )
                );
              }
            })
            .catch((err) => {
              dispatchSnackbar(
                setSnackbar(true, "error", t("snackbar.createProjectItemError"))
              );
            });
    } else {
      dispatchSnackbar(
        setSnackbar(true, "error", t("snackbar.mandatoryFields"))
      );
    }
  }

  return (
    <>
      <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          elevation={0}
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 }, align: "center" }}
        >
          <Box
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "5px",
                }}
              >
                {t("hydraPro.mainData")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "7px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  id="name"
                  label={t("hydraPro.posName")}
                  name="name"
                  value={hydraUnit.name}
                  onChange={handleChange}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="poolName"
                  label={t("hydraPro.poolName")}
                  name="poolName"
                  value={hydraUnit.poolName}
                  onChange={handleChange}
                />
              </Box>
              <FormControl fullWidth>
                <InputLabel
                  id="select-label14"
                  sx={{ mt: "8px", color: "#373437" }}
                >
                  {t("hydraPro.poolType")}
                </InputLabel>
                <Select
                  disablePortal
                  MenuProps={{ disableScrollLock: true }}
                  fullWidth
                  value={hydraUnit.typeOfPool}
                  sx={{ mt: 1, mb: "15px" }}
                  labelId="select-label14"
                  name="typeOfPool"
                  label={t("hydraPro.poolType")}
                  // defaultValue={"Enthalpy"}
                  onChange={handleChange}
                  defaultValue={hydraUnit.typeOfPool}
                >
                  {typesOfPool.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ display: "flex", gap: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  id="poolVolume"
                  label={t("hydraPro.poolVolume")}
                  name="poolVolume"
                  value={hydraUnit.poolVolume}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        m<sup>3</sup>
                      </InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="waterSurface"
                  label={t("hydraPro.waterSurface")}
                  name="waterSurface"
                  value={hydraUnit.waterSurface}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {" "}
                        m<sup>2</sup>
                      </InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "15px",
                }}
              >
                {t("hydraPro.thermodynamicParams")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  id="airTemperature"
                  label={t("hydraPro.airTemp")}
                  name="airTemperature"
                  value={hydraUnit.airTemperature}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">°C</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="waterTemperature"
                  label={t("hydraPro.waterTemp")}
                  name="waterTemperature"
                  value={hydraUnit.waterTemperature}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">°C</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="arithmeticMeanTemperature"
                  label={t("hydraPro.arithmeticMean")}
                  name="arithmeticMeanTemperature"
                  value={hydraUnit.arithmeticMeanTemperature.toFixed()}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">K</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="gasConstant"
                  label={t("hydraPro.gasConst")}
                  name="gasConstant"
                  value={hydraUnit.gasConstant}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">J/kgK</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="airHumidity "
                  label={t("hydraPro.airHumid")}
                  name="airHumidity"
                  value={hydraUnit.airHumidity}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "15px",
                }}
              >
                {t("hydraPro.pressures")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="partialWaterVaporSaturationPressure100"
                  label={t("hydraPro.partialWaterVapor")}
                  name="partialWaterVaporSaturationPressure100"
                  value={hydraUnit.partialWaterVaporSaturationPressure100.toFixed()}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">Pa</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="partialWaterVaporSaturationPressure"
                  label={t("hydraPro.partialSaturationPressure")}
                  name="partialWaterVaporSaturationPressure"
                  value={hydraUnit.partialWaterVaporSaturationPressure.toFixed()}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">Pa</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "15px",
                }}
              >
                {t("hydraPro.absHum")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="absoluteHumidityPoolArea"
                  label={t("hydraPro.absHumInPoolArea")}
                  name="absoluteHumidityPoolArea"
                  value={hydraUnit.absoluteHumidityPoolArea.toPrecision(3)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/kg</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="absoluteHumidityAir"
                  label={t("hydraPro.absoluteHumidityAir")}
                  name="absoluteHumidityAir"
                  value={hydraUnit.absoluteHumidityAir}
                  onChange={handleChange}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.001,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/kg</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                }}
              >
                {t("hydraPro.attractions")}
              </Typography>

              <Typography
                onClick={() => setShowAttractions(!showAttractions)}
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "22px",
                }}
              >
                {showAttractions
                  ? t("hydraPro.clickToClose")
                  : t("hydraPro.clickToOpen")}
              </Typography>
            </Box>
            {showAttractions && (
              <Box sx={{ marginBottom: "20px" }}>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="wildWaterChannels"
                      label={t("hydraPro.wildWaterChannels")}
                      name="wildWaterChannels"
                      value={hydraUnit.wildWaterChannels}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>{" "}
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      disabled
                      fullWidth
                      id="relWildWater"
                      label={t("hydraPro.relWildWater")}
                      name="relWildWater"
                      value={hydraUnit.relWildWater}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="waterMushrooms"
                      label={t("hydraPro.waterMushrooms")}
                      name="waterMushrooms"
                      value={hydraUnit.waterMushrooms}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box width="50%">
                    <TextField
                      margin="normal"
                      fullWidth
                      id="waterMushroomsMeters"
                      label={t("hydraPro.waterMushroomsMeters")}
                      name="waterMushroomsMeters"
                      // autoComplete={t("createproject.wetBulbTemperatureCelsius")}
                      value={hydraUnit.waterMushroomsMeters}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">m</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box width="50%">
                    <TextField
                      margin="normal"
                      disabled
                      fullWidth
                      id="relWaterMushroomsMeters"
                      label={t("hydraPro.relWaterMushroomsMeters")}
                      name="relWaterMushroomsMeters"
                      value={hydraUnit.relWaterMushrooms}
                      onChange={handleChange}
                      //onBlur={validate}
                      //onKeyDown={handleKeyDown}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">m</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="neckMassageShowers"
                      label={t("hydraPro.neckMassageShowers")}
                      name="neckMassageShowers"
                      value={hydraUnit.neckMassageShowers}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      disabled
                      fullWidth
                      id="relNeckMassageShower"
                      label={t("hydraPro.relNeckMassageShower")}
                      name="relNeckMassageShower"
                      value={hydraUnit.relNeckMassageShowers}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="underwaterJets"
                      label={t("hydraPro.underwaterJets")}
                      name="underwaterJets"
                      value={hydraUnit.underwaterJets}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      disabled
                      fullWidth
                      id="relUnderwaterJets"
                      label={t("hydraPro.relUnderwaterJets")}
                      name="relUnderwaterJets"
                      value={hydraUnit.relUnderwaterJets}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="bubbleFountains"
                      label={t("hydraPro.bubbleFountains")}
                      name="bubbleFountains"
                      value={hydraUnit.bubbleFountains}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      disabled
                      id="relBubbleFountains"
                      label={t("hydraPro.relBubbleFountains")}
                      name="relBubbleFountains"
                      value={hydraUnit.relBubbleFountains}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="childrenSlides"
                      label={t("hydraPro.childrenSlides")}
                      name="childrenSlides"
                      value={hydraUnit.childrenSlides}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      disabled
                      fullWidth
                      id="relChildrenSlides"
                      label={t("hydraPro.relChildrenSlides")}
                      name="relChildrenSlides"
                      value={hydraUnit.relChildrenSlides}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="massageAreas"
                      label={t("hydraPro.massageAreas")}
                      name="massageAreas"
                      value={hydraUnit.massageAreas}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      disabled
                      id="relMassageAreas"
                      label={t("hydraPro.relMassageAreas")}
                      name="relMassageAreas"
                      value={hydraUnit.relMassageAreas}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      id="loungersSeats"
                      label={t("hydraPro.loungersSeats")}
                      name="loungersSeats"
                      value={hydraUnit.loungersSeats}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      disabled
                      id="relLoungersSeats"
                      label={t("hydraPro.relLoungersSeats")}
                      name="relLoungersSeats"
                      value={hydraUnit.relLoungersSeats}
                      onChange={handleChange}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">pcs</InputAdornment>
                        ),
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}
                >
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      disabled
                      id="sum"
                      label={t("hydraPro.sum")}
                      name="sum"
                      value={hydraUnit.sum}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                    />
                  </Box>
                  <Box sx={{ width: "50%" }}>
                    <TextField
                      margin="normal"
                      fullWidth
                      disabled
                      id="betaA"
                      label={t("hydraPro.betaA")}
                      name="betaA"
                      value={hydraUnit.betaA.toFixed(1)}
                      inputType="number"
                      type="number"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        step: 0.1,
                      }}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    id="simultaneityFactorAttraction"
                    label={t("hydraPro.simultaneityFactorAttraction")}
                    name="simultaneityFactorAttraction"
                    value={hydraUnit.simultaneityFactorAttraction}
                    onChange={handleChange}
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      step: 0.1,
                    }}
                  />
                  <TextField
                    margin="normal"
                    fullWidth
                    id="numberOfVisitors"
                    label={t("hydraPro.numberOfVisitors")}
                    name="numberOfVisitors"
                    value={hydraUnit.numberOfVisitors}
                    onChange={handleChange}
                    inputType="number"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                      step: 1,
                    }}
                  />
                </Box>
              </Box>
            )}

            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "15px",
                }}
              >
                {t("hydraPro.maxAmountCalc")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="moistureTransferCoefficientUnusedPool"
                  label={t("hydraPro.moistureTransferCoefficientUnusedPool")}
                  name="moistureTransferCoefficientUnusedPool"
                  value={hydraUnit.moistureTransferCoefficientUnusedPool}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">m/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="moistureTransferCoefficientUsedPool"
                  label={t("hydraPro.moistureTransferCoefficientUsedPool")}
                  name="moistureTransferCoefficientUsedPool"
                  value={hydraUnit.moistureTransferCoefficientUsedPool}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">m/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="moistureTransferCoefficientAttraction"
                  label={t("hydraPro.moistureTransferCoefficientAttraction")}
                  name="moistureTransferCoefficientAttraction"
                  // autoComplete={t("createproject.wetBulbTemperatureCelsius")}
                  value={hydraUnit.moistureTransferCoefficientAttraction}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">m/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="amountMoistureVisitors"
                  label={t("hydraPro.amountMoistureVisitors")}
                  name="amountMoistureVisitors"
                  value={hydraUnit.amountMoistureVisitors.toFixed(1)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="massFlowWaterUnusedPool"
                  label={t("hydraPro.massFlowWaterUnusedPool")}
                  name="massFlowWaterUnusedPool"
                  // autoComplete={t("createproject.wetBulbTemperatureCelsius")}
                  value={hydraUnit.massFlowWaterUnusedPool.toFixed(1)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />{" "}
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="massFlowWaterUsedPool"
                  label={t("hydraPro.massFlowWaterUsedPool")}
                  name="massFlowWaterUsedPool"
                  value={hydraUnit.massFlowWaterUsedPool.toFixed(1)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "25px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="massFlowWaterFromAttraction"
                  label={t("hydraPro.massFlowWaterFromAttraction")}
                  name="massFlowWaterFromAttraction"
                  value={hydraUnit.massFlowWaterFromAttraction.toFixed(1)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  disabled
                  id="totalMassFlowWaterUsedPool"
                  label={t("hydraPro.totalMassFlowWaterUsedPool")}
                  name="totalMassFlowWaterUsedPool"
                  value={hydraUnit.totalMassFlowWaterUsedPool.toFixed(1)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>

            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "15px",
                }}
              >
                {t("hydraPro.maxAirVol")}
              </Typography>

              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="massFlowOutsideAir"
                  label={t("hydraPro.massFlowOutsideAir")}
                  name="massFlowOutsideAir"
                  value={hydraUnit.massFlowOutsideAir.toFixed()}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="maxRequiredAir"
                  label={t("hydraPro.maxRequiredAir")}
                  name="maxRequiredAir"
                  value={hydraUnit.maxRequiredAir}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        m<sup>3</sup>/h
                      </InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "15px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="minRequiredFreshAir"
                  label={t("hydraPro.minRequiredFreshAir")}
                  name="minRequiredFreshAir"
                  value={hydraUnit.minRequiredFreshAir}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {" "}
                        m<sup>3</sup>/h
                      </InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="numOfAirChanges"
                  label={t("hydraPro.numOfAirChanges")}
                  name="numOfAirChanges"
                  value={hydraUnit.numOfAirChanges.toFixed(2)}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start"> 1/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
            </Box>
            <Box sx={{ marginBottom: "20px" }}>
              <Typography
                component="h2"
                variant="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "28px" },
                  marginRight: "10px",
                  marginBottom: "7px",
                }}
              >
                {t("hydraPro.ahuSelectionSize")}
              </Typography>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "7px" }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="select-label15"
                    sx={{ mt: 1, color: "#373437" }}
                  >
                    {t("hydraPro.unitType")}
                  </InputLabel>
                  <Select
                    disablePortal
                    MenuProps={{ disableScrollLock: true }}
                    fullWidth
                    value={hydraUnit.unitType}
                    sx={{ mt: 1, mb: 1 }}
                    labelId="select-label15"
                    name="unitType"
                    label={t("hydraPro.unitType")}
                    onChange={handleChange}
                  >
                    {unitTypes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel
                    id="select-label16"
                    sx={{ mt: 1, color: "#373437" }}
                  >
                    {t("hydraPro.unitSize")}
                  </InputLabel>
                  <Select
                    disablePortal
                    MenuProps={{ disableScrollLock: true }}
                    fullWidth
                    value={hydraUnit.unitSize}
                    sx={{ mt: 1, mb: 1 }}
                    labelId="select-label16"
                    name="unitSize"
                    label={t("hydraPro.unitSize")}
                    onChange={handleChange}
                    defaultValue={hydraUnit.unitSize}
                  >
                    {unitSizes.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel
                    id="select-label17"
                    sx={{ mt: 1, color: "#373437" }}
                  >
                    {t("hydraPro.numberOfUnits")}
                  </InputLabel>
                  <Select
                    disablePortal
                    MenuProps={{ disableScrollLock: true }}
                    fullWidth
                    value={hydraUnit.numOfUnits}
                    sx={{ mt: 1, mb: 1 }}
                    labelId="select-label17"
                    name="numOfUnits"
                    label={t("hydraPro.numberOfUnits")}
                    onChange={handleChange}
                    defaultValue={hydraUnit.numOfUnits}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="airFlowPerUnit"
                  label={t("hydraPro.airFlowPerUnit")}
                  name="airFlowPerUnit"
                  value={hydraUnit.airFlowPerUnit}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {" "}
                        m<sup>3</sup>/h
                      </InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="width"
                  label={t("hydraPro.width")}
                  name="width"
                  value={hydraUnit.width}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">mm</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="height"
                  label={t("hydraPro.height")}
                  name="height"
                  value={hydraUnit.height}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">mm</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="length"
                  label={t("hydraPro.length")}
                  name="length"
                  value={hydraUnit.length}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">mm</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="unitWeight"
                  label={t("hydraPro.unitWeight")}
                  name="unitWeight"
                  value={hydraUnit.unitWeight}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
                <TextField
                  margin="normal"
                  disabled
                  fullWidth
                  id="dehumidificationCapacity"
                  label={t("hydraPro.dehumidificationCapacity")}
                  name="dehumidificationCapacity"
                  value={hydraUnit.dehumidificationCapacity}
                  inputType="number"
                  type="number"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    step: 0.1,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">kg/h</InputAdornment>
                    ),
                    onWheel: (e) => e.target.blur(),
                  }}
                />
              </Box>
              <TextField
                margin="normal"
                disabled
                fullWidth
                id="price"
                label={t("hydraPro.price")}
                name="price"
                value={hydraUnit.price}
                inputType="number"
                type="number"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  step: 0.1,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">€</InputAdornment>
                  ),
                  onWheel: (e) => e.target.blur(),
                }}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                sx={{
                  mt: 2,
                  mb: 2,
                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                  color: theme.palette.secondary.main,
                  // padding: "6px 40px",
                  width: { xs: "80%", sm: "30%" },
                  fontSize: 26,
                  transition: "all 0.5s",
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    color: theme.palette.secondary.main,
                  },
                }}
                onClick={createPosition}
              >
                {t("hydraPro.save")}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </>
  );
}
DehumidifyCalc.whyDidYouRender = true;

export default DehumidifyCalc;
